@if (isWorkOrderList) {
  <div class="pure-g m-t-16" style="align-items: center">
    <div
      class="pure-g pure-u-md-18-24 pure-u-lg-19-24 pure-u-xl-20-24"
      style="overflow: auto; text-wrap: nowrap; display: flex; align-items: center">
      @if (selectedRows.length == 0) {
        <ng-container>
          <div style="width: 90px; display: inline-block; font-size: 0.9rem">Quick Filters:</div>
          @for (option of untaggedStatusList; track option.generatedCode) {
            @if ($index < numberOfQuickFiltersToShow) {
              <mc-button
                [attr.data-cy]="option.description"
                class="m-r-8 tag-button"
                [label]="option.description"
                variant="filled"
                appearance="neutral"
                fit="small"
                padding="compact"
                (click)="selectStatusFromQuickFilter(option)"></mc-button>
            } @else {
              @if ($index === numberOfQuickFiltersToShow) {
                <mc-popover style="position: relative" trigger="click" position="bottom-left">
                  <div slot="trigger" class="overflow-count">+{{ untaggedStatusList.length - numberOfQuickFiltersToShow }}</div>
                  <div class="tag-button-container">
                    @for (option of untaggedStatusList.slice(numberOfQuickFiltersToShow); track option.generatedCode) {
                      <mc-button
                        [attr.data-cy]="option.description"
                        class="m-r-8 tag-button"
                        [label]="option.description"
                        variant="filled"
                        appearance="neutral"
                        fit="small"
                        padding="compact"
                        (click)="selectStatusFromQuickFilter(option)"></mc-button>
                    }
                  </div>
                </mc-popover>
              }
            }
          }
        </ng-container>
      } @else {
        @if (authPolicies.canEditWorkOrder) {
          <div class="action-buttons">
            <!-- Mark Complete Button (Always Visible, but Disabled if Invalid Selection) -->
            @if (!isMarkAsCompleteValid) {
              <app-button-with-confirmation
                label="Mark Complete"
                appearance="neutral"
                modalBody="{{ selectedRows.length }} Work Orders will be Marked Complete. Are you sure you want to proceed?"
                modalHeading="Confirm Bulk Completion"
                confirmButtonLabel="Confirm"
                cancelButtonLabel="Cancel"
                [loading]="markCompleteApiCallStatus === 'IN_PROGRESS'"
                [onConfirm]="markAsCompleteValid()">
              </app-button-with-confirmation>
            } @else {
              <mc-button label="Mark Complete" fit="small" appearance="neutral" (click)="markAsCompleteInvalid()"> </mc-button>
            }
            <!-- Error Message (Only Shown When Invalid Work Orders are Selected) -->
          </div>
        }
      }
    </div>

    <div class="pure-u-md-6-24 pure-u-lg-5-24 pure-u-xl-4-24 right">
      @if (bulkWorkOrderEnabled()) {
        @if (canUserCreateWO) {
          <app-aems-button-group
            label="Single Equipment"
            parentButtonRouterLink="/workorders/create/single-equipment"
            [menuItems]="[
              {
                label: 'Multiple Equipments',
                routerLink: '/workorders/create/multiple-equipments',
              },
            ]"></app-aems-button-group>
        }
      } @else {
        @if (canUserCreateWO) {
          <mc-button
            label="Single Equipment"
            routerLink="/workorders/create/single-equipment"
            variant="filled"
            appearance="primary"
            fit="small"></mc-button>
        }
      }
    </div>
  </div>
}
<div class="m-t-8 quick-filter-box">
  <div class="applied-filter-holder">
    @for (taggedFilter of taggedFilters; track taggedFilter.key) {
      <div class="m-r-4" style="white-space: nowrap">
        {{ taggedFilter.key }}
      </div>

      @if (isArrayType(taggedFilter.value)) {
        @if (taggedFilter.key == 'WO Number' && getTaggedWorkOrderNumbers()) {
          <app-tag-with-overflow
            [data]="getTaggedWorkOrderNumbers()"
            [overflowCount]="2"
            [withaction]="true"
            [dismiss]="unselectWorkorderNumber()"></app-tag-with-overflow>
        }

        @if (taggedFilter.key == 'Equipment Id' && getTaggedEquipmentNumbers()) {
          <app-tag-with-overflow
            [data]="getTaggedEquipmentNumbers()"
            [overflowCount]="2"
            [withaction]="true"
            [dismiss]="unselectEquipmentNumber()"></app-tag-with-overflow>
        }

        @if (taggedFilter.key == 'Mode' && getTaggedModes()) {
          @for (taggedMode of getTaggedModes(); track taggedMode.code) {
            <mc-tag
              class="m-r-4 extra-height"
              appearance="neutral-inverse"
              fit="small"
              withaction
              (click)="unselectSpecificFilter(taggedFilter, getTaggedModes().indexOf(taggedMode))"
              >{{ getTaggedFilterValue(taggedFilter, getTaggedModes().indexOf(taggedMode)) }}</mc-tag
            >
          }
        } @else if (taggedFilter.key == 'Status' && getTaggedStatuses()) {
          @for (taggedStatus of getTaggedStatuses(); track taggedStatus.generatedCode) {
            <mc-tag
              class="m-r-4 extra-height"
              appearance="neutral-inverse"
              fit="small"
              withaction
              (click)="unselectSpecificFilter(taggedFilter, getTaggedStatuses().indexOf(taggedStatus))"
              >{{ getTaggedFilterValue(taggedFilter, getTaggedStatuses().indexOf(taggedStatus)) }}</mc-tag
            >
          }
        } @else if (taggedFilter.key == 'Shop ID' && getTaggedShops()) {
          @for (taggedShop of getTaggedShops(); track taggedShop) {
            <mc-tag
              class="m-r-4 extra-height"
              appearance="neutral-inverse"
              fit="small"
              withaction
              (click)="unselectSpecificFilter(taggedFilter, getTaggedShops().indexOf(taggedShop))"
              >{{ getTaggedFilterValue(taggedFilter, getTaggedShops().indexOf(taggedShop)) }}</mc-tag
            >
          }
        }
      } @else {
        <mc-tag
          class="m-r-4 extra-height"
          appearance="neutral-inverse"
          fit="small"
          withaction
          (click)="unselectSpecificFilter(taggedFilter)"
          >{{ getTaggedFilterValue(taggedFilter) }}</mc-tag
        >
      }
    }
    @if (taggedFilters.length > 0) {
      <a>
        <mc-button class="clear-btn" variant="plain" appearance="primary" fit="small" padding="default" (click)="clearAllSelectedFilters()">
          Clear All
        </mc-button>
      </a>
    }
  </div>
  <div class="utility-buttons">
    <!-- <div>
                <mc-button class="utility-button download" label="Button " variant="filled" appearance="neutral"
                    fit="medium" icon="cog" hiddenlabel padding="default">
                </mc-button>
            </div> -->
    <div class="pure-g">
      @if (advancedFilterLoading) {
        <div style="padding: 9px 11px">
          <mc-loading-indicator hiddenlabel appearance="primary"> </mc-loading-indicator>
        </div>
      } @else {
        <mc-tooltip appearance="neutral-default" fit="small" position="bottom-center">
          <mc-button
            class="utility-button"
            slot="trigger"
            label="Button"
            icon="sliders-horizontal"
            variant="filled"
            appearance="neutral"
            hiddenlabel
            padding="default"
            fit="medium"
            (click)="showAdvanceFiltersModal()">
          </mc-button>
          <span>Filters</span>
        </mc-tooltip>
      }

      <mc-modal
        (opened)="advancedFilterHasOpened()"
        [open]="showAdvanceFilters"
        (closed)="closeAdvanceFiltersModal()"
        heading="Filters"
        fit="small"
        dimension="large">
        <app-advance-filter
          [isWorkOrderList]="isWorkOrderList"
          [workOrderFilterForm]="filterFormGroup.controls.workOrderFilterForm"></app-advance-filter>
      </mc-modal>
    </div>
  </div>
</div>
